import { render, staticRenderFns } from "./barNew1.vue?vue&type=template&id=03e55f3a&scoped=true&"
import script from "./barNew1.vue?vue&type=script&lang=js&"
export * from "./barNew1.vue?vue&type=script&lang=js&"
import style0 from "./barNew1.vue?vue&type=style&index=0&id=03e55f3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e55f3a",
  null
  
)

export default component.exports